import CalculatorsController from '../../src/javascripts/cvm';
import SymplrWfm from '../../src/javascripts/models/symplr/wfm';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/symplr/wfm/hubspot_helpers';
import '../../src/javascripts/helpers/symplr/wfm/investment_calculations';
import '../../src/javascripts/helpers/symplr/wfm/production_selection_dependencies';
import '../../src/javascripts/helpers/symplr/wfm/annual_labor_expense_calculator';
import '../../src/javascripts/helpers/symplr/wfm/fte_on_payroll_team_calculator';
import '../../src/javascripts/helpers/symplr/wfm/fte_managing_staffing_calculator';
import '../../src/javascripts/helpers/symplr/wfm/physicians_on_staff_calculator';
import '../../src/javascripts/helpers/symplr/wfm/nurses_on_staff_calculator';
import '../../src/javascripts/helpers/symplr/wfm/pagers_in_use_calculator';
import '../../src/javascripts/helpers/symplr/wfm/patient_discharges_per_year_calculator';
import '../../src/javascripts/helpers/symplr/wfm/self_service';
import '../../src/stylesheets/symplr/symplr_shared.scss';
import '../../src/stylesheets/symplr/wfm.scss';

(function() {
  $(() => CalculatorsController.run(new SymplrWfm()));
}).call(this);
